import classNames from 'classnames';
import { generatePath } from 'react-router-dom';

import { getFormattedCreatedAt } from '@utils/common';
import { publicMemberProfile } from '@urls';
import { Link } from '@ui/Link';
import { Image } from '@ui/Image';
import { Stars } from '@ui/Stars';

import s from './ReviewInCatalog.sss';

interface Owner {
  id: number,
  username: string,
}

interface Product {
  id: number,
  name: string,
  thumbnail: string,
  url: string,
}

interface Props {
  className?: string,
  buyer: Owner,
  product?: Product | null,
  updatedAt: string,
  text: string,
  overallRating: number,
}

export const ReviewInCatalog: React.FC<Props> = ({
  className,
  buyer,
  product,
  updatedAt,
  text,
  overallRating,
}) => {
  if (!product) {
    return null;
  }

  return (
    <div className={classNames(s.root, className)}>
      <Link
        className={s.productLink}
        theme="clean"
        href={product.url}
      >
        <Image
          className={s.thumbnail}
          src={product.thumbnail}
          alt={product.name}
          lazy={true}
        />
      </Link>

      <div className={s.content}>
        <div className={s.header}>
          <div className={s.owner}>
            <Link
              className={s.username}
              theme="black"
              to={generatePath(publicMemberProfile, { username: buyer.username })}
            >
              {buyer.username}
            </Link>

            <div className={s.stars}>
              <Stars
                value={overallRating}
                readOnly={true}
              />
            </div>
          </div>

          <time
            className={s.date}
            dateTime={updatedAt}
          >
            {getFormattedCreatedAt(updatedAt)}
          </time>
        </div>

        <Link
          className={s.title}
          theme="black"
          href={product.url}
        >
          {product.name}
        </Link>

        <p className={s.text}>
          {text}
        </p>
      </div>
    </div>
  );
};
